export default __webpack_public_path__ + "static/media/new_dasboard_medication_icon.15889952.svg";